import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { VerifyUser } from '../validators/userDetails.validator';
import { VerifyUserName } from '../../shared/validators/username.validator'
import { VerifyFullName } from '../validators/fullname.validators';
import { UsernameValidator } from '../../shared/validators/usernameasync.validator';
import { SettingsService } from '../settings.service';
import { startWith, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { VerifyEmail } from 'src/app/shared/validators/email.validator';
import { SharedService } from 'src/app/services/shared.service';
import { ToastService } from 'src/app/shared/custom-overlay/toast/toast.service';
import { ToastType } from 'src/app/shared/shared.enums';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit, AfterViewInit,OnDestroy {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private ref:MatDialogRef<UserComponent>,
    private fb:UntypedFormBuilder,
    private sharedService:SharedService,
    private settingservice:SettingsService,
    private toastService: ToastService
  ) { }

  usermeta = this.sharedService.metaData.settings.createuserData;
  validationData = this.sharedService.metaData.commonData.userDetailvalidationData
  submitState:boolean = false;
  timezoneoptions: any = this.sharedService.metaData.commonData.timezoneList;
  inputBoxEmitChar =  this.sharedService.metaData.commonData.specialCharList.charList;
  emailchar =  this.sharedService.metaData.commonData.specialCharList.emailCharList;
  numCharList = this.sharedService.metaData.commonData.specialCharList.numCharList;
  mat_spinner_user_state:boolean
  $destroy:Subject<any> = new Subject()
  timerangeDisabled:boolean = false;
  userDetailValueChange:boolean = false;
  execptSpecialCharater = ["@",'.']
  initialUserDetailsValue:any ={} 

  userDetail = this.fb.group({
    // username:[null,[Validators.required, VerifyUserName(),Validators.maxLength(this.validationData.username.maxlength),Validators.minLength(this.validationData.username.minlength)],[UsernameValidator.createValidator(this.settingservice)]],
    username:[null,[Validators.required, VerifyUserName(),Validators.maxLength(30),Validators.minLength(this.validationData.username.minlength)],[UsernameValidator.createValidator(this.settingservice)]],
    password:[null,[Validators.required,Validators.minLength(this.validationData.password.minlength),Validators.maxLength(this.validationData.password.maxlength)]],
    firstname:[null,[Validators.required,VerifyFullName(),Validators.maxLength(60)]],
    lastname:['',[VerifyFullName(),Validators.maxLength(60)]],
    mobile:[null,[Validators.required,Validators.pattern("^[0-9]{10}$")]],
    email:[null,[Validators.required,VerifyEmail(), Validators.email, Validators.maxLength(this.validationData.email.maxlength)]],
    // email:[null,[Validators.required, Validators.email, Validators.maxLength(this.validationData.email.maxlength)]],

    role:[null,[Validators.required]],
    default_platform:[null,[Validators.required]],
    timezone:["UTC",[Validators.required]],
    authenticationType:[null,[Validators.required]],
    authenticationUrl:[null],
    active:[null],
    block:[false],
    forcepwd:[true],
    fromTime:[null],
    toTime:[null],
    passwordChanged:[false],
    clearBlockedInterval:[false]
    
  },{validators:VerifyUser()})

  ngOnInit() {
    this.validationData.username.errors.invalidName ="Invalid username (user@org)"
    console.log(this.validationData)
    this.allowSpecialCharacters()
//console.log(this.usermeta.formmsg,this.validationData)
    this.usermeta.formmsg.default_platform = {
      "errors":{
        "required":"Default platform is required",
        "customError":"Default platform not available from selected roles"
      }
  }
  
    this.timezone.disable();
    this.mat_spinner_user_state=true
    this.authenticationType.valueChanges
    .pipe(
    startWith(this.authenticationType.value),
    takeUntil(this.$destroy))
    .subscribe((val)=>{
      let index = this.usermeta.formmsg.authtypeurl.typefilterOptions.indexOf(val)
      if(index>=0){
        this.authenticationUrl.setValue(this.usermeta.formmsg.authtypeurl.urlfilterOptions[index])
      }
    })
    if(this.data.editState){
      this.userDetail.addControl('pendingemail',this.fb.control(this.data.editdata.pendingemail))
      this.userDetail.addControl('pendingmobile', this.fb.control(this.data.editdata.pendingmobile))
      const editdata = this.mobileDataChange(this.data.editdata,0);
      this.password.disable();
      this.username.disable();
      // this.email.setValidators()
      this.userDetail.patchValue(editdata)
      // this.email.setValidators([Validators.required, Validators.email, Validators.maxLength(this.validationData.email.maxlength)])
    }else{
      this.userDetail.patchValue(this.usermeta.defaultValues)
    }
    if(!this.data.matspin){
      this.mat_spinner_user_state=false
    }


    this.block.valueChanges.subscribe((val)=>{
      this.blockUser(val);
    })

    this.blockUser(this.block.value);
    this.initialUserDetailsValue = this.userDetail.value
    this.userDetail.valueChanges.subscribe(val=>{
      // this.userDetailValueChange = true
      if(JSON.stringify(this.initialUserDetailsValue) != JSON.stringify(this.userDetail.value)){
        this.userDetailValueChange = true
//console.log("userDetail.valueChanges======",val)
      }
    })
  }

  allowSpecialCharacters(){
    for(let characterType  in this.sharedService.metaData.commonData.specialCharList){
      let arr = this.sharedService.metaData.commonData.specialCharList[characterType]
      for(let char of this.execptSpecialCharater){
        let index = arr.indexOf(char);
        if (index > -1) { // only splice array when item is found
          arr.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
      this.sharedService.metaData.commonData.specialCharList[characterType]=arr
    }
  }
  ngAfterViewInit(): void {
    this.authenticationUrl.disable()

    // this.username.valueChanges.subscribe(data=>{
    //   console.log(this.username)
    // })
    
  }

  get username(){
    return this.userDetail.get('username')
  }

  get password(){
    return this.userDetail.get('password')
  }

  get firstname(){
    return this.userDetail.get('firstname')
  }

  get lastname(){
    return this.userDetail.get('lastname')
  }

  get mobile(){
    return this.userDetail.get('mobile')
  }

  get email(){
    return this.userDetail.get('email')
  }
  
  get role(){
    return this.userDetail.get('role')
  }

  get default_platform(){
    return this.userDetail.get('default_platform')
  }

  get timezone(){
    return this.userDetail.get('timezone')
  }

  get authenticationType(){
    return this.userDetail.get('authenticationType')
  }

  get authenticationUrl(){
    return this.userDetail.get('authenticationUrl')
  }

  get pendingmobile() {
    return this.userDetail.get('pendingmobile')
  }

  get pendingemail(){
    return this.userDetail.get('pendingemail')
  }

  get passwordChanged(){
    return this.userDetail.get('passwordChanged')
  }

  get fromTime(){
    return this.userDetail.get('fromTime')
  }

  get toTime(){
    return this.userDetail.get('toTime')
  }

  get clearBlockedInterval(){
    return this.userDetail.get('clearBlockedInterval')
  }

  get block(){
    return this.userDetail.get('block')
  }

  get forcepwd(){
    return this.userDetail.get('forcepwd')
  }

  blockUser(state:boolean){
    if(state){
      this.fromTime.enable();
      this.toTime.enable();
    } else {
      this.fromTime.disable();
      this.toTime.disable();
    }
  }

  editPasswordClick(){
    this.password.enable()
    this.passwordChanged.setValue(true)
    this.password.reset()
  }

  mobileApproveClick(val:number){
    if(val === -1){
      this.mobile.setValue(this.data.editdata.oldmobile)
    }
    this.pendingmobile.setValue(val)
  }

  emailApproveClick(val:number){
    if(val === -1){
      this.email.setValue(this.data.editdata.oldemail)
    }
    this.pendingemail.setValue(val)
  }

  closedialogClick(){
    this.ref.close()
  }

  mobileDataChange(val:any,state:number){
    if(state){
      Number(val.mobile)
    }else{
      if(val.mobile){
        val.mobile.toString()
      }else{
        val.mobile = ''
      }
    }
    return val
  }
  
  checkRoleChanged(postval:any){
    if(this.data.editdata.role.toString() !== this.role.value.toString()){
      postval["rolechanged"] = true;
    }else {
      postval["rolechanged"] = false;
    }

    if(this.data.editdata.timezone.toString() !== this.timezone.value.toString()){
      postval["timezonechanged"] = true;
    }else {
      postval["timezonechanged"] = false;
    }

    return postval;
  }

  checkDefaultPlatformChanged(postval:any){
    if(this.data.editdata.default_platform.toString() !== this.default_platform.value.toString()){
      postval["defaultPlatformChanged"] = true;
    }else {
      postval["defaultPlatformChanged"] = false;
    }
    return postval;
  }

 

  clearInterval(formvalue){
    if(formvalue.clearBlockedInterval){
      formvalue['fromTime'] = null;
      formvalue['toTime'] = null;
    }
    return formvalue;
  }

  checkDefaultPlatform(){
    let selectedRole = this.role.value
    let selectedPlatform = this.default_platform.value
    if(selectedRole && selectedPlatform){
      for (let role of selectedRole){

        let platformIndex = this.data.roleplatformlist[role].indexOf(selectedPlatform)
        if(platformIndex > -1){
          return true
        }
      }
      this.default_platform.setErrors({customError:true})
      return false
    }
    else{
      return false
    }
    
  }

  submitUser(){
    this.submitState = true;
       let checkDefaultPlatformState = this.checkDefaultPlatform()
    if(this.userDetail.valid){
      this.mat_spinner_user_state = true
      let userdetail = this.mobileDataChange(this.userDetail.getRawValue(),1)
      userdetail = this.clearInterval(userdetail)
      
      if(this.data.editState){
        userdetail['oldmobile'] = this.data.editdata.oldmobile;
        userdetail['oldemail'] = this.data.editdata.oldemail;
        userdetail = this.checkDefaultPlatformChanged(userdetail);
        userdetail = this.checkRoleChanged(userdetail);
        this.settingservice.postEditUser(userdetail)
        .pipe(takeUntil(this.$destroy))
        .subscribe((val:any)=>{
          this.mat_spinner_user_state = false
          this.submitState = false;
          this.ref.close(val);
          this.toastService.ShowToaster(this.usermeta.toastmsg.changes,ToastType.success)
        },
        (err)=> {
          this.mat_spinner_user_state = false;
          this.ref.close({"status":0})
        })
      }else{
          
          this.settingservice.postNewUser(userdetail)
          .pipe(takeUntil(this.$destroy))
          .subscribe((val:any)=>{
            this.mat_spinner_user_state = false
          this.submitState = false;
          this.ref.close(val)
          this.toastService.ShowToaster(this.usermeta.toastmsg.success,ToastType.success)
        },
        (err)=> {
          this.mat_spinner_user_state = false;
          this.ref.close({"status":0})
        })
      }
    }
  }
  ngOnDestroy(): void {
    this.$destroy.next()
  }
}